export const DEFAULT_MAX_VALUE = 100;
export const GRID_LEVELS = 4;
export const CHART_RADIUS_RATIO = 0.88;
export const TOOLTIP_OFFSET = { top: -8, left: 12 };
export const FALLBACK_SIZE = 280;

export const GRID_STROKE_WIDTH = 1;
export const GRID_FILL_OPACITY_MULTIPLIER = 0.15;

export const PRIMARY_POLYGON_STROKE_WIDTH = 2;
export const PRIMARY_POLYGON_STROKE_OPACITY = 0.6;
export const PRIMARY_POLYGON_FILL_OPACITY = 0.45;
export const PRIMARY_POLYGON_FILL_OPACITY_HOVERED = 0.6;

export const SECONDARY_POLYGON_STROKE_WIDTH = 1.5;
export const SECONDARY_POLYGON_STROKE_OPACITY = 0.4;
export const SECONDARY_POLYGON_FILL_OPACITY = 0.25;
export const SECONDARY_POLYGON_FILL_OPACITY_HOVERED = 0.35;

export const AXIS_DOT_RADIUS = 4;
export const AXIS_DOT_FILL_OPACITY = 0.7;
export const HOVER_TARGET_STROKE_WIDTH = 28;
